import React from 'react';
import personIcon from '../../assets/images/person.png';
import phoneIcon from '../../assets/images/phone.png';
import loactionIcon from '../../assets/images/location.png';
import InfoIcon from '../../assets/images/info-circle.png';
import editIcon from '../../assets/images/edit.svg';


const PatientInfoCard = ({ patientName, patientPhone, pincode, condition, showEdit = false, onEditClick }) => {
    return (
        <div style={styles.infoCard}>
            <div style={{ ...styles.cardTitle, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>Patient Details</span>
                {showEdit && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }} onClick={onEditClick}>
                        <img
                            src={editIcon}
                            alt="edit"
                            style={{ width: 16, height: 16, filter: 'invert(36%) sepia(88%) saturate(1444%) hue-rotate(6deg) brightness(98%) contrast(102%)' }} // orange tint
                        />
                        <span style={{ fontSize: 10, color: '#FE8235', marginTop: 2 }}>Edit</span>
                    </div>
                )}

            </div>

            <div style={styles.rowIcon}>
                <img src={personIcon} alt="person" style={styles.iconImage} />
                <span style={styles.rowText}>{patientName}</span>
            </div>

            <div style={styles.rowIcon}>
                <img src={phoneIcon} alt="phone" style={styles.iconImage} />
                <span style={styles.rowText}>+91 {patientPhone}</span>
            </div>

            <div style={styles.rowIcon}>
                <img src={loactionIcon} alt="pincode" style={styles.iconImage} />
                <span style={styles.rowText}>Pin Code: {pincode}</span>
            </div>

            <div style={styles.rowIcon}>
                <img src={InfoIcon} alt="phone" style={styles.iconImage} />
                <span style={styles.rowText}>Condition: {condition}</span>
            </div>
        </div>
    );
};

const styles = {
    infoCard: {
        backgroundColor: "#fff",
        margin: "14px 10px",
        borderRadius: 20,
        padding: 16,
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    },
    cardTitle: {
        color: "#2E2E2E",
        fontSize: "18px",
        fontWeight: "600",
        marginBottom: "12px",
    },
    rowIcon: {
        display: "flex",
        alignItems: "center",
        marginBottom: 6,
    },
    iconImage: {
        width: 16,
        height: 16,
        objectFit: "contain",
        marginRight: 8,
    },
    rowText: {
        fontSize: 16,
        color: "#1D1617",
        fontWeight: 500,

    },
};
export default PatientInfoCard;
